import React, { useEffect, useRef, useState, useMemo } from "react";
import "./detail.css";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { CourseContentModuleRowComponent } from "../../components/ModuleContentRowComponent/index-v2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useMoodleV2 } from "../../contexts/moodle";
import { Navbar } from "../../components/Navbar";
import { useAuth } from "../../contexts/AuthContext";
import { getUserNru } from "../../services/tipddy/nru";
import { defaultSenceValidation } from "../../utils/handler";
import { SenceValidation } from "../../services/sence";
import { FormSence } from "../../services/sence/form";
import { useTimer } from "../../components/Timer";
import { CustomDialog } from "../../components/Dialog";
import { LIMIT_CRON_DIALOG } from "../../utils/state";
import { CustomSpinner } from "../../components/Loader/custom.spinner";
import { useTheme } from "../../contexts/ThemeContext";
import groupIcon from "../../assets/grupo-gris.png";
import { darken, readableColor, transparentize } from "polished";
import { useConfig } from "../../contexts/config";
import useActivityCompleted from "../../hooks/useActivityCompleted";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './index.css'
import es_ES from '@react-pdf-viewer/locales/lib/es_ES';
// import { local } from "d3";

export const DetailCourseV2 = () => {
  const auth = useAuth();
  const { lang } = useAuth();
  const params = useParams();
  const { config } = useConfig();
  const moodlev2 = useMoodleV2();
  const theme = useTheme();
  const navigate = useNavigate();
  // const [refresh, setRefresh] = useState(0);
  const [layout, setLayout] = useState(true);
  const [loading, setLoading] = useState(true);
  const [messageReady, setMessageReady] = useState(false);
  const [group, setGroup] = useState(null);
  const [message, setMessage] = React.useState({
    open: false,
    title: "",
    message: "",
    isBeforeunload: true,
  });
  const [navigating, setNavigating] = useState(0);
  const { limit } = useTimer();
  const { activityCompletedButtonClicked } = useActivityCompleted(null);

  const contentFixedBar = document.getElementById("content-fixed-bar")

  // const fetchCurrentCourseProgress = async () => {
  //   const data = await moodlev2.getCourseProgressPercentage(params.id);
  //   data ? setRefresh(refresh + 1) : setRefresh(refresh);
  //   console.log(refresh, data);
  //   localStorage.setItem("courseProgress", data);
  //   return data;
  // };

  // useEffect(() => {
  //   fetchCurrentCourseProgress();
  //   //eslint-disable-next-line
  // }, []);

/*   useEffect(() => {
    lang && console.log(lang["Coursedetail"]);
  }, [lang]);
 */
  useEffect(() => {
    moodlev2.getCourseUserList(params.id).then((res) => {
      //console.log("group: ", res);
      setGroup(res);
    });
    //eslint-disable-next-line
  }, [params.id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [params.id]);

  useEffect(() => {
    if (params.id === undefined) {
      navigate("/listcourses");
    } else {
      moodlev2
        .getCourseContentByID(params.id, true, window.location.search)
        .catch((err) => {
          console.error("Error loading course content:", err);
          navigate("/listcourses");
        });
    }
  }, [params.id])
/*   useEffect(() => {
  if (
    moodlev2.currentModules &&
    moodlev2.currentResourceId &&
    moodlev2.currentModuleId
  ) {
    const currentModule = moodlev2.currentModules.find(
      (m) => m.id === moodlev2.currentModuleId
    );
    const currentResource = currentModule?.modules.find(
      (r) => r.id === moodlev2.currentResourceId
    );
    if (currentModule && currentResource) {
      moodlev2.setIframeLoaded(false);
      moodlev2.requestPageEmbed({
        pageurl: currentResource.url,
        module: currentModule,
        resource: currentResource,
        course_id: moodlev2.currentCourseId,
      });
    }
  }
  // Solo ejecuta cuando los módulos y el recurso actual cambian
}, [moodlev2.currentModules, moodlev2.currentResourceId, moodlev2.currentModuleId]);
 */
  

  async function fetchNRU() {
    // console.log({ userData: auth.user });
    //console.log(config);
    let args = {
      courseid: moodlev2.currentCourse.id,
      userid: auth.user.id,
      username: auth.user.username,
      clientid: config.ID,
    };
    return Promise.resolve(await getUserNru(args));
  }

  function isSenceRequired(isSence, nru) {
    let required = false;
    let session = localStorage.getItem("sence_session");
    if (isSence && nru && !session) {
      required = true;
    }
    return required;
  }

  async function VerifySence() {
    // Si ya validó Sence, no volver a ejecutar
  if (localStorage.getItem("sence_validated") === "1") {
    setLoading(false);
    return;
  }
    console.log(moodlev2.currentCourse);
    let data = defaultSenceValidation(moodlev2.currentCourse);
    console.log({ defaultSenceValidation: data.isSence });
    if (data.isSence) {
      let nru = null;
      /* let rawNru = await fetchNRU(); // comentado para forzar el flujo sence
      console.log({ rawNru }); */
      let rawNru = [{ rnu: "6679142" }];
      if (rawNru && rawNru.length > 0) {
        nru = rawNru[0].rnu;
        localStorage.setItem("nru", nru);
      }
      //let isRequired = isSenceRequired(data.isSence, nru);
      //console.log({ isSenceRequired: isRequired });
      if (data.isSence && nru) { // ! Julio pide que siempre se pida clave única
        let validation = {
          idSence: data.idSence,
          auth,
          session: null,
          isLogin: true,
          nru,
        };
        localStorage.setItem("idSence", data.idSence);
        localStorage.setItem("current_course", params.id);
        // Setea el flag ANTES de enviar a Sence
        localStorage.setItem("sence_validated", "1");
        /* console.log(auth);
        console.log(validation); */
        return SenceValidation(validation);
      } else {
        return setLoading(false);
      }
    } else {
      return setLoading(false);
    }
  }

  React.useEffect(() => {
    if (
      moodlev2.currentCourse &&
      localStorage.getItem("last_login_sence" && !messageReady)
    ) {
      window.onbeforeunload = function (e) {
        e = e || window.event;
        if (e) {
          e.returnValue = "Sure?";
        }
        return "Sure?";
      };
      setMessageReady(true);
      setMessage({
        ...message,
        open: true,
        title: "Bienvenido a su curso Sence",
        message:
          "No olvides cerrar sesión Sence al finalizar, cuando queden 10 segundos de sesión se redireccionará automáticamente a Sence para cerrar su sesión",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moodlev2.currentCourse]);

  React.useEffect(() => {
    if (
      localStorage.getItem("last_login_sence") &&
      limit > LIMIT_CRON_DIALOG &&
      message.isBeforeunload
    ) {
      window.onbeforeunload = function (e) {
        return null;
      };
      setMessage({
        ...message,
        open: true,
        title: "Quedan 2 minutos para cerrar sesión",
        message:
          "Si desea cerrar sesión manualmente, haga click en cerrar Sence o espere 2 minutos",
        isBeforeunload: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  React.useEffect(() => {
    if (moodlev2.currentCourse) {
      console.log("VerifySence");
      VerifySence();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moodlev2.currentCourse]);

// auto scroll al contenido de la pagina
// In DetailCourseV2 component - update the auto-scroll useEffect
/* useEffect(() => {
  if (moodlev2.currentResourceId && moodlev2.currentModules) {
    setTimeout(() => {
      // Find the current resource element more specifically
      const currentResourceElement = document.querySelector('.current-resource-item');
      
      if (currentResourceElement) {
        // Get the content container for scrolling
        const contentContainer = document.querySelector('.content-container');
        if (contentContainer) {
          // Calculate position to scroll to
          const resourceOffsetTop = currentResourceElement.getBoundingClientRect().top + 
                                   contentContainer.scrollTop - 
                                   contentContainer.getBoundingClientRect().top;
          
          // Always scroll to position resource in the upper part of the viewport
          contentContainer.scrollTo({
            top: resourceOffsetTop - 100, // Position with padding from top
            behavior: 'smooth'
          });
          
          console.log('Scrolling to resource at:', resourceOffsetTop - 100);
        }
      } else {
        console.log('Current resource element not found');
      }
    }, 500); // Increased delay to ensure DOM is ready after animations
  }
}, [moodlev2.currentResourceId, moodlev2.currentModules, navigating]); */

  function handleContentLayout() {
    setLayout(!layout);
  }

  return (
    <>
      {lang && (
        <>
          {loading && <CustomSpinner />}
          <FormSence />
          <Navbar layout={layout} handleContentLayout={handleContentLayout} />
          <DetailCourseWrapper>
            <CoreVisualContent
              moodlev2={moodlev2}
              token={auth.user.token}
              layout={layout}
              handleContentLayout={handleContentLayout}
              lang={lang}
              setNavigating={setNavigating}
            />
            <CourseContentContainer
              handleContentLayout={handleContentLayout}
              layout={layout}
            >
              {/* <DiagnosticEvaluationButton /> */}
              <div id="content-fixed-bar" className="sticky top-[-1px] z-50 py-2" style={{backgroundColor: theme.colors.backgroundColorDetailCourse}}>
                <CourseTitle moodleV2={moodlev2} params={params} />
                <TabsRow lang={lang} />
              </div>
              {group && <GroupRow group={group} />}
              <ContentPickerContainer>
                {moodlev2.currentModules &&
                  moodlev2.currentModules.map((module, idx) => {
                    console.log(module);
                    if(module.name === "Tema 1"){
                      return null
                    }
                    if (
                      module.modules[0]?.name ===
                      "Este curso no posee sesiones en línea"
                    ) {
                      return (
                        <div key={idx}>
                          <p
                            style={{
                              color: readableColor(
                                theme.colors.backgroundColorDetailCourse
                              ),
                            }}
                          >
                            Este curso no posee sesiones en línea
                          </p>
                        </div>
                      );
                    }
                    if (
                      module.name &&
                      module.name === "Programas" &&
                      module.modules.length === 0
                    ) {
                      return (
                        <div key={idx}>
                          <p
                            style={{
                              color: readableColor(
                                theme.colors.backgroundColorDetailCourse
                              ),
                            }}
                          >
                            Este curso no posee programas
                          </p>
                        </div>
                      );
                    }
                    return (
                      <CourseContentModuleRowComponent
                        module={module}
                        key={module.id}
                        moodle={moodlev2}
                        idx={idx}
                        navigating={navigating}
                        contentFixedBar={contentFixedBar?.scrollHeight}
                      />
                    );
                  })}
                {!moodlev2.currentModules && <SkeletonModules />}
              </ContentPickerContainer>
            </CourseContentContainer>
          </DetailCourseWrapper>
          <CustomDialog
            open={message.open}
            title={message.title}
            message={message.message}
            onCancel={() => setMessage({ ...message, open: false })}
            onConfirm={() => setMessage({ ...message, open: false })}
          />
        </>
      )}
    </>
  );
};

const SkeletonModules = () => {
  return (
    <>
      {[1, 2, 3, 4, 5].map((k, i) => {
        return <SkeletonModule key={i} />;
      })}
    </>
  );
};

const SkeletonModule = () => {
  return (
    <div
      style={{ display: "flex", padding: "1.2rem", alignItems: "center" }}
    >
      <Skeleton
        baseColor="#adb5bd"
        style={{
          opacity: 0.1,
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          marginRight: "1rem",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        <Skeleton
          baseColor="#adb5bd"
          style={{
            opacity: 0.1,
            width: "210px",
            height: "12px",
            marginLeft: "5px",
            borderRadius: "10px",
          }}
        />
        <Skeleton
          baseColor="#adb5bd"
          style={{
            opacity: 0.1,
            width: "210px",
            height: "12px",
            marginLeft: "5px",
            borderRadius: "10px",
          }}
        />
        <Skeleton
          baseColor="#adb5bd"
          style={{
            opacity: 0.1,
            width: "150px",
            height: "12px",
            marginLeft: "5px",
            borderRadius: "10px",
          }}
        />
      </div>
    </div>
  );
};

const DetailCourseWrapper = ({ children, token }) => {
  const theme = useTheme();
  return (
    <div
      className="detail-course-container"
      style={{
        backgroundColor: theme.colors.backgroundColorBody,
        height: "100dvh"
      }}
      id="course-wrapper"
    >
      <div 
        className="row mx-0 " 
        // style={{ height: "92dvh", maxHeight: "92dvh" }}
        style={{ height: "100%", maxHeight: "100%" }}
      >
        {children}
      </div>
    </div>
  );
};

const CoreVisualContent = ({
  moodlev2,
  token,
  layout,
  handleContentLayout,
  lang,
  setNavigating,
}) => {
  let embed = moodlev2.pageEmbed;
  let resourceContent = moodlev2.labelContent;

  const auth = useAuth();
  const {config} = useConfig()
  const frame = React.useRef(null);
  const { iframeLoaded, setIframeLoaded, iframeKey } = moodlev2;
  const theme = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  /*   const {config} = useConfig() */

    useEffect(() => {
      const checkMobile = () => {
        const ua = navigator.userAgent;
        const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        setIsMobile(iOS || (isSafari && /mobile/i.test(ua)));
      };
      checkMobile()
    /* console.log(moodlev2)
    console.log(moodlev2.currentResourceId)
    console.log(embed)
    console.log(config) */
}, [moodlev2])

  const handleIframeLoad = () => {
    console.log("contenido cargado");
    setTimeout(() => {
      setIframeLoaded(true);
    }, 400);
  };

  React.useEffect(() => {
    let refreshTrigger = localStorage.getItem("refresh");
    let newaccess = Number(localStorage.getItem("newaccess"));
    if (!refreshTrigger && newaccess) {
      let last = newaccess;
      let new_ = auth.user.id;
      let refresh = last === new_ ? false : true;
      if (refresh && frame.current !== null) {
        frame.current.addEventListener("load", () => {
          let url = window.location.pathname;
          localStorage.setItem("refresh", true);
          localStorage.removeItem("newaccess");
          window.location.replace(`${url}?watch=${new Date().getTime()}`);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frame]);

  /* Inicio codigo que recibe postMessage para poder cotejar si el iframe se encuentra en listado curso
   * el cual no debería estar visible
   */
  function transformURL(url) {
    // Escapar los caracteres especiales en la URL
    let escapedURL = url.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&");
    // Construir la expresión regular con la parte variable
    let regexString = escapedURL + "course\\/view\\.php\\?id=\\d+";
    // Crear la expresión regular
    let regex = new RegExp(regexString);
    return regex;
  }

  React.useEffect(() => {
    console.log(embed)
    window.addEventListener("message", function (event) {
      let url = config.baseURL;
      let urlPattern = transformURL(url);
      // Verifica que el mensaje provenga del dominio esperado
      if (urlPattern.test(event.data.href)) {
        // redireccionar iframe a pagina 404
        frame.current.src = `${url}course/404.php`;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [embed]);
  /* Fin codigo recibir postMessaage */

  /* Inicio Image Embed code */

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
    renderToolbar: (Toolbar) => (
      <Toolbar></Toolbar>
    ),
  });


  const handleImgToken = (html, token) => {
    // Crear un elemento div para cargar el HTML como texto
    let src_token_with_param = `?token=${token}`;
    let src_token_without_param = `&token=${token}`;
    let div = document.createElement("div");
    div.innerHTML = html;

    // Obtener todas las etiquetas de imagen
    let imagenes = div.getElementsByTagName("img");

    // Recorrer todas las etiquetas de imagen y agregar el token al final del atributo src
    for (let i = 0; i < imagenes.length; i++) {
      let src = imagenes[i].getAttribute("src");
      if (src.includes("?")) {
        imagenes[i].setAttribute("src", src + src_token_without_param);
      } else {
        imagenes[i].setAttribute("src", src + src_token_with_param);
      }
    }

    // Devolver el HTML modificado
    return div.innerHTML;
  };

  const restrictedModule = useMemo(() => {
    if (!embed || !embed.endsWith(`id=${moodlev2.currentResourceId}`) || !moodlev2.currentModules) {
      return null;
    }
    for (const currentModule of moodlev2.currentModules) {
      const foundModule = currentModule.modules.find((mod) => mod.id === moodlev2.currentResourceId);
      if (foundModule && foundModule.uservisible === false) {
        return foundModule;
      }
    }
    return null;
  }, [embed, moodlev2.currentResourceId, moodlev2.currentModules]);

  useEffect(() => {
    if (!restrictedModule) return;
    const container = document.querySelector(".availability-wrapper");
    if (!container) return;
    const showMoreBtn = container.querySelector('[data-action="showmore"] a');
    if (!showMoreBtn) return;

    const handleClick = (e) => {
      e.preventDefault();

      // Mostrar li ocultos
      const hiddenItems = container.querySelectorAll("li.d-none");
      hiddenItems.forEach((item) => {
        item.classList.remove("d-none");
        item.classList.add("d-block");
      });

      // Mostrar spans ocultos
      const hiddenSpans = container.querySelectorAll("span.d-none");
      hiddenSpans.forEach((span) => {
        span.classList.remove("d-none");
        span.classList.add("d-block");
      });

      // Eliminar los "..."
      const dots = container.querySelectorAll("span.d-block");
      dots.forEach((dot) => {
        if (dot.textContent?.trim() === "...") {
          dot.remove();
        }
      });

      // Eliminar botón Mostrar más
      showMoreBtn.closest("li")?.remove();
    };

    showMoreBtn.addEventListener("click", handleClick);

    return () => {
      showMoreBtn.removeEventListener("click", handleClick);
    };
  }, [restrictedModule]);

  if (restrictedModule) {
    const linkcapGreen =
      theme.colors.button_light && theme.colors.button_light !== "#fdbf00"
        ? theme.colors.button_light
        : "#40ac3d";

    return (
      <div
        className={layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html"}
        style={{
          position: "relative",
          height: "100%",
          transition: "0.5s",
          marginBottom: "4px",
        }}
      >
        <div className="flex justify-center" style={{ height: "calc(100% - 32px)" }}>
          <div
            className="rounded-2xl p-4 sm:p-6 shadow-lg leading-relaxed h-fit w-full self-center max-w-[728px]"
            style={{
              color: "#ffffff",
              backgroundColor: linkcapGreen,
              fontSize: "16px",
            }}
          >
            <div
              className="availability-wrapper [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mb-2 [&_strong]:font-semibold [&_.d-none]:hidden [&_li.d-block]:!list-item [&_li.d-block.showmore]:!block [&_.showmore]:mt-3 [&_a]:text-white [&_a]:underline [&_a:hover]:opacity-85 overflow-x-auto"
              dangerouslySetInnerHTML={{ __html: restrictedModule.availabilityinfo }}
            />
          </div>
        </div>

        <NavigationButtons layout={layout} lang={lang} setNavigating={setNavigating} />
      </div>
    );
  }

  if (embed && embed.includes("<img")) {
    let new_embed = handleImgToken(embed, token);

    return (
      <div
        className={layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html"}
        style={{
          position: "relative",
          height: "100%",
          /* borderBottom: "2px solid #ccc", */
          transition: "0.5s",
          marginBottom: "4px",
        }}
      >
        <div
          ref={frame}
          style={{
            maxHeight: "100%",
            width: "100%",
            overflow: "scroll",
            backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
          }}
          dangerouslySetInnerHTML={{ __html: new_embed }}
        ></div>
        <NavigationButtons
          layout={layout}
          lang={lang}
          setNavigating={setNavigating}
        />
      </div>
    );
  }
  //embed = "https://e-aula.academia-tecnigen.cl/webservice/pluginfile.php/36286/mod_resource/content/2/El%20Impacto%20del%20Contacto%20Prolongado%20de%20Materia%20Organica%20en%20el%20Instrumental%20Quirurgico%20-%20TECNIGEN.pdf?token=3d2298782f70d3c297b05160ed73f1f1"
  if(/* isMobile &&  */embed && embed.toLowerCase().includes('.pdf')){
    console.log('entra a mobile pdf')
    return (
      <div
        className={layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html"}
        style={{
          height: "93dvh",
          position: "relative",
          padding: "0 0 80px 0",
          transition: "0.1s",
        }}
      >
        {/* {!iframeLoaded && (
          <div className="absolute inset-0 bg-[#000] flex items-center justify-center z-10" style={{ transition: "background-color 0.1s ease", height: "90%" }}>
            <div
              className="size-16 border-[6px] border-gray-300 rounded-full animate-spin"
              style={{ borderTopColor: theme.mode === "light" ? theme.colors.button_light : theme.colors.button_dark }}
            ></div>
          </div>
        )} */}
        {/* <iframe
          key={iframeKey}
          ref={frame}
          id="iframePdf"
          type="application/pdf"
          scrolling="auto"
          src={`https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(embed)}&embedded=true`}
          width="100%"
          className="h-[100%]"
          frameBorder="0"
          title="pdf-viewer"
          onLoad={handleIframeLoad}
          style={{
            transition: "opacity 0.5s",
            marginBottom: "4px",
            opacity: iframeLoaded ? 1 : 0,
            backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
          }}
        /> */}

        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
        <Viewer localization={es_ES} fileUrl={embed} plugins={[defaultLayoutPluginInstance]} onDocumentLoad={handleIframeLoad} />
      </Worker>

        <NavigationButtons layout={layout} lang={lang} setNavigating={setNavigating} />
      </div>
    );
  }

  /* Fin Image Embed */
  if (embed && !embed.startsWith("http")) {
    return (
      <div
        className={layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html"}
        style={{
          position: "relative",
          height: "100%",
          /* borderBottom: "2px solid #ccc", */
          marginBottom: "4px",
          transition: "0.5s",
        }}
      >
        <div
          ref={frame}
          style={{
            maxHeight: "100%",
            width: "100%",
            overflow: "scroll",
            backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
          }}
          dangerouslySetInnerHTML={{ __html: embed }}
        ></div>
        <NavigationButtons
          layout={layout}
          lang={lang}
          setNavigating={setNavigating}
        />
      </div>
    );
  }

    /* Inicio Label content */
/*     if (resourceContent && !embed) {
      return (
        <div
          className={layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html"}
          style={{
            position: "relative",
            height: "100%",
            borderBottom: "2px solid #ccc",
            transition: "0.5s",
          }}
        >
          <div
            style={{
              maxHeight: "100%",
              width: "100%",
              overflow: "scroll",
            }}
            dangerouslySetInnerHTML={{ __html: resourceContent }}
          ></div>
          <NavigationButtons layout={layout} /> 
        </div>
      );
    } */


  return (
    <div
      className={layout ? "col-xl-9 summary-html" : "col-xl-12 summary-html"}
      style={{
        position: "relative",
        minHeight: "100%",
        padding: "0 0 80px 0",
        transition: "0.1s",
      }}
    >
      {!iframeLoaded && (
        <div className="absolute inset-0 bg-transparent flex items-center justify-center z-10" style={{ transition: "background-color 0.1s ease", height: "90%" }}>
          <div
            className="size-16 border-[6px] border-gray-300 rounded-full animate-spin"
            style={{ borderTopColor: theme.mode === "light" ? theme.colors.button_light : theme.colors.button_dark }}
          ></div>
        </div>
      )}
      <iframe
        key={iframeKey}
        ref={frame}
        src={embed}
        id="video-player"
        frameBorder="0"
        width="100%"
        allow="autoplay ; microphone; camera; fullscreen;"
        height={"99%"}
        title="video"
        onLoad={handleIframeLoad}
        style={{
          /* borderBottom: "2px solid #ccc", */ transition: "opacity 0.5s",
          marginBottom: "4px",
          opacity: iframeLoaded ? 1 : 0,
          backgroundColor: theme.mode === "light" ? "#FAFAFA" : "#fff",
        }}
      />
      <NavigationButtons
        layout={layout}
        lang={lang}
        setNavigating={setNavigating}
      />
    </div>
  );
};

const CourseContentContainer = ({ children, layout }) => {
  return (
    <div
      className={layout ? "col-xl-3" : "col-xl-0"}
      id="scrollable-modules-wrapper"
      style={{
        height: "calc(100% - 32px)",
        maxHeight: "100%",
        overflowY: "scroll",
        /* padding: "0.5rem", */
        /* paddingTop: "1rem", */
        /* borderLeft: "1px solid rgb(104, 183, 202)", */
        position: "relative",
        transition: "0.5s",
      }}
    >
      {children}
    </div>
  );
};

const DiagnosticEvaluationButton = () => {
  const moodlev2 = useMoodleV2();
  const [, /* isCompleted */ setCompleted] = useState(false);

  React.useEffect(() => {
    /* console.log(moodlev2.diagnostic); */
    if (moodlev2.diagnostic && moodlev2.diagnostic.length > 0) {
      let evaluation = moodlev2.diagnostic[0];
      let isCompleted = evaluation.completiondata?.state !== 0 || null;
      setCompleted(isCompleted);
    }
  }, [moodlev2.diagnostic]);

  /* console.log(moodlev2.diagnostic); */

  if (!moodlev2.diagnostic) {
    return null;
  }

  return (
    <button
      type="button"
      className="btn btn-primary btn-lg btn-block btn-evaluacion"
    >
      Realizar Evaluación Diagnóstica
    </button>
  );
};

const CourseTitle = ({ moodleV2, params }) => {
  const [title, setTitle] = useState("titulo");
  const theme = useTheme();
  const { user } = useAuth();

  useEffect(() => {
    if (moodleV2 && moodleV2.courses) {
      let course_title = moodleV2.courses.filter(
        (e) => e?.id === Number(params.id)
      );
      console.log(course_title);
      if (course_title[0]) {
        setTitle(course_title[0].displayname);
      } else {
        setTitle("");
      }
    }
    if (moodleV2 && !moodleV2.courses && user.id && user.token) {
      moodleV2.getCourses();
    }
    //eslint-disable-next-line
  }, [moodleV2?.courses, user]);

  return (
    <div
      className="mx-2 mb-4 pb-2"
      style={{
        borderBottomWidth: "1px",
        borderColor: "#ccc",
        borderStyle: "solid",
      }}
    >
      <h2
        className="text-3xl font-outfit font-semibold"
        style={{
          color: readableColor(
            theme.colors.backgroundColorDetailCourse,
            "#1a1a1a",
            "#f2f2f2",
            false
          ),
        }}
      >
        {title}
      </h2>
    </div>
  );
};

const TabsRow = ({ lang }) => {
  const moodle = useMoodleV2();
  const {config} = useConfig()
  const theme = useTheme();
  const [color, setColor] = useState("");

  useEffect(() => {

    if (theme) {
      let calcColor =
        theme.mode === "light"
          ? theme.colors.tertiary_light
          : theme.colors.tertiary_dark;
          let newColor = readableColor(darken(0.2,calcColor), "#ffffff", "#000000");
      console.log(newColor + (moodle.selectedView === 0 ? "66" : "33"));
      setColor(newColor);
    }
  }, [theme]);

/*   useEffect(() => {
    console.log(moodle.selectedView);
  }, [moodle.selectedView]); */

  /*   React.useEffect(() => {
    console.log("moodle.humhub: ", moodle.humhub);
  }, [moodle.humhub]); */

  return (
    <div className="flex flex-row justify-center mb-2 gap-2 h-24">
      <button
        type="button"
        className={`${
          moodle.humhub ? "col-md-4 btn btn-primary btn-tab-course" : ""
        }  font-medium text-2xl desktop:text-[1.7rem] px-4 py-2 rounded-md hover:brightness-125 transition-all w-full h-full`}
        onClick={() => moodle.contentSelected()}
        style={{
          backgroundColor:
            moodle.selectedView === 0
              ? (theme.mode === "light"
                  ? theme.colors.backgroundCompletadoLight
                  : theme.colors.backgroundCompletadoDark)
              : theme.colors
                  .backgroundColorNotCurrentTab /* (theme.colors.tertiary_dark) + (moodle.selectedView === 0 ? "66" : "33") , */,
          color: moodle.selectedView === 0 ? color : readableColor(theme.colors.backgroundColorNotCurrentTab,"#ffffff", "#000000")
        }}
        /* style={{
          backgroundColor:
            moodle.selectedView === 0
              ? theme.mode === "light"
                ? "#7D7D7D"
                : "#FFCC00"
              : "#fff",
          color:
            moodle.selectedView === 0
              ? theme.mode === "light"
                ? "#fff"
                : "#333"
              : "#333",
        }} */
      >
        {lang["Coursedetail"].content}
      </button>

      {config.opciones && config.opciones.includes("programa") && (
        <button
          type="button"
          className={`${
            moodle.humhub ? "col-md-6 btn btn-primary btn-tab-course" : ""
          } font-medium text-2xl desktop:text-[1.7rem] px-4 py-2 rounded-md hover:brightness-125 transition-all w-full h-full`}
          onClick={() => moodle.programSelected()}
          style={{
            backgroundColor: moodle.selectedView === 1 ? theme.colors.backgroundColorCurrentTab : theme.colors.backgroundColorNotCurrentTab,
            color: moodle.selectedView === 1 ? "#000" : "#fff",
          }}
        >
          Programa
        </button>
      )}

      {moodle.humhub && (
        <button
          type="button"
          className=" font-medium text-2xl  desktop:text-[1.7rem] px-4 py-2 rounded-md hover:brightness-125 transition-all w-full"
          onClick={() => moodle.humhubSelected()}
          style={{
            backgroundColor:
              moodle.selectedView === 2
                ? (theme.mode === "light"
                  ? theme.colors.backgroundCompletadoLight
                  : theme.colors.backgroundCompletadoDark)
                : theme.colors.backgroundColorNotCurrentTab,
            color: moodle.selectedView === 1 ? color : readableColor(theme.colors.backgroundColorNotCurrentTab,"#ffffff", "#000000")
          }}
          /* style={{
            backgroundColor:
              moodle.selectedView === 1
                ? theme.mode === "light"
                  ? "#7D7D7D"
                  : "#FFCC00"
                : "#fff",
            color: moodle.selectedView === 1 ? "#fff" : "#333",
          }} */
        >
          {lang["Coursedetail"].forum}
        </button>
      )}

      <button
        type="button"
        className={`${
          moodle.humhub ? "col-md-4 btn btn-primary btn-tab-course" : ""
        } font-medium text-2xl desktop:text-[1.7rem] px-4 py-2 rounded-md hover:brightness-125 transition-all w-full`}
        onClick={() => moodle.onlineSelected()}
        style={{
          backgroundColor:
            moodle.selectedView === 2
              ? (theme.mode === "light"
                  ? theme.colors.backgroundCompletadoLight
                  : theme.colors.backgroundCompletadoDark)
              : theme.colors.backgroundColorNotCurrentTab,
          color: moodle.selectedView === 2 ? color : readableColor(theme.colors.backgroundColorNotCurrentTab,"#ffffff", "#000000")
        }}
        /* style={{
          backgroundColor:
            moodle.selectedView === 2
              ? theme.mode === "light"
                ? "#7D7D7D"
                : "#FFCC00"
              : "#fff",
          color: moodle.selectedView === 2 ? "#fff" : "#333",
        }} */
      >
        {lang["Coursedetail"].online_class}
      </button>
    </div>
  );
};

const GroupRow = ({ group }) => {
  return (
    <div className="row mx-0 group-row">
      <div className="group-text">
        <img className="group-icon" src={groupIcon} alt="group icon" />
        Grupo: {group}
      </div>
    </div>
  );
};

const ContentPickerContainer = ({ children }) => {
  return (
    <div
      className="content-container rounded-md"
      // className="content-container rounded-md !pb-8 laptop:!pb-[160px]"
      id="content-modules-container"
      style={{
        overflowY: "unset",
        height: "100%",
        // height: "calc(100% - 168px)",
        // paddingBottom: 160,
        scrollbarWidth: "thin",
        scrollbarColor: "#000 #333",
        "::-webkit-scrollbar": {
          width: "8px",
        },
        "::-webkit-scrollbar-track": {
          background: "#333",
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: "#000",
          borderRadius: "10px",
          border: "2px solid #333",
        },
        /* cursor: "pointer", */
      }}
    >
      {children}
    </div>
  );
};

const NavigationButtons = ({ layout, lang, setNavigating }) => {
  const theme = useTheme();
  const moodlev2 = useMoodleV2();
  const { iframeLoaded, setIframeLoaded } = moodlev2;
  const [btnText, setBtnText] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const styles = {};

  styles.container = {
    position: "absolute",
    bottom: 32,
    right: layout ? 10 : 170,
    zIndex: 10,
    width: "fit-content",
    display: "flex",
    backgroundColor: "transparent",
    padding: "0rem",
    transition: "0.5s",
  };

  styles.innerContainer = {
    display: "flex",
    alignItems: "center",
    border: "1px solid #b2b2b233",
    borderRadius: 9,
  };

  styles.prevButton = {
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    height: 42,
    width: 120,
    backgroundColor: theme.colors.backgroundColorPrevBtn,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1.2rem",
    paddingLeft: "0.2rem",
  };

  styles.nextButton = {
    backgroundColor: theme.colors.backgroundColorNextBtn,
    color: readableColor(theme.colors.backgroundColorNextBtn),
    height: 42,
    width: "100%",
    padding: "1.2rem",
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor:
      moodlev2.nextResourceName === "Fin del curso" ? "default" : "pointer",
  };

  styles.contentTableButton = {
    backgroundColor: theme.colors.backgroundColorPrevBtn,
    color: theme.mode === "dark" ? "#000" : "#fff",
    height: 42,
    
    borderRadius: 8,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    padding: "1.2rem",
  };


  styles.arrowRightIcon = { transform: "translateY(1px)", fontSize: "28px"  };

  styles.arrowLeftIcon = { color: theme.mode === "dark" ? "#fff" : "#fff", fontSize: "28px" };

  const handleNext = async () => {
    setNavigating((prev) => prev + 1);
    if (moodlev2.nextResourceName === "Fin del curso") {
      return;
    } else {
      setIframeLoaded(false);
      await moodlev2.navigateNext();
    }
  };

  const handlePrev = async () => {
    setNavigating((prev) => prev + 1);
    setIframeLoaded(false);
    await moodlev2.navigatePrev();
  };

  const handleNavButtonText = (dic, text) => {
    if (text === "Fin del curso") {
      return dic["Coursedetail"].finish_course;
    }
    if (text?.includes("Siguiente Unidad:")) {
      let new_result =
        dic["Coursedetail"].next_topic +
        ": " +
        text.split("Siguiente Unidad:")[1];
      return new_result;
    }
    return text;
  };

  useEffect(() => {
    setBtnText(handleNavButtonText(lang, moodlev2.nextResourceName));
    // Check if device is mobile
    const checkMobile = () => {
      const ua = navigator.userAgent;
      const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
      setIsMobile(iOS || isMobileDevice);
    };
    
    checkMobile();
    //eslint-disable-next-line
  }, [moodlev2.nextResourceName]);

  const handleScrollToContent = () => {
    const contentContainer = document.querySelector('.content-container');
    if (contentContainer) {
      contentContainer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div style={styles.container}>

      <div style={styles.innerContainer}>
      {isMobile && (
          <div 
            className="hover:brightness-110 h-fit px-4" 
            style={styles.contentTableButton} 
            onClick={handleScrollToContent}
          >
            <p className="m-0 text-2xl">Contenidos</p>
          </div>
        )}
        <div className="hover:brightness-110" style={styles.prevButton} onClick={handlePrev}>
          <KeyboardArrowLeftIcon sx={styles.arrowLeftIcon} /> <p className="m-0 next-button text-[12px] laptop:text-[14px] line-clamp-2 text-white">Retroceder</p>
        </div>
        <div className="hover:brightness-110 max-w-[60vw]" style={styles.nextButton} onClick={handleNext}>
          <p className="m-0 next-button text-[12px] laptop:text-[14px] line-clamp-2">Continuar a {btnText}</p>
          {moodlev2.nextResourceName === "Fin del curso" ? (
            <></>
          ) : (
            <>
            
            <KeyboardArrowRightIcon sx={styles.arrowRightIcon} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
